module.exports = __webpack_public_path__ + "static/image9@2x-9d4225a68f1e98a320b0ee376b9714c9.png";